import React from 'react';

/**
 * CancellationPolicyPanel — where the shop admin sets the minimum
 * hours a customer must give when self-cancelling via the /cancel/{token}
 * link in their confirmation email. Enforced server-side by the
 * `/api/email/cancel-booking` route.
 *
 * Kept as its own panel (not folded into Business hours) because it's
 * a different mental model — hours are "when we're open", this is
 * "when the customer can still bail without calling us".
 */
export const CancellationPolicyPanel = ({ form, onChange }) => {
  const value = Number.isFinite(Number(form.cancellation_notice_hours))
    ? Number(form.cancellation_notice_hours)
    : 24;
  return (
    <div className="panel" style={{ padding: 18, marginBottom: 14 }} data-testid="cancellation-policy-panel">
      <b style={{ fontSize: 15 }}>Cancellation notice</b>
      <small style={{ display: 'block', color: 'var(--mute)', marginTop: 2, fontSize: 12.5, lineHeight: 1.4 }}>
        Minimum hours a customer must give before their appointment to cancel themselves via the link in their confirmation email. Cancellations inside this window ask the customer to call you instead. Doesn't apply to you — you can still cancel any booking from the Diary at any time.
      </small>
      <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <label style={{ fontSize: 13, color: 'var(--mute)' }}>Minimum notice</label>
        <input
          className="inp"
          type="number"
          min={0}
          max={168}
          step={1}
          value={value}
          onChange={(e) => onChange({ cancellation_notice_hours: Math.max(0, Math.min(168, Number(e.target.value) || 0)) })}
          data-testid="cancellation-notice-hours"
          style={{ width: 100, padding: '6px 8px', fontSize: 13 }}
        />
        <span style={{ fontSize: 13, color: 'var(--ink)' }}>hours</span>
      </div>
    </div>
  );
};

export default CancellationPolicyPanel;
